var map = {
	"./ar.json": "af08",
	"./da.json": "21aa",
	"./de.json": "6ce2",
	"./en.json": "edd4",
	"./eo.json": "2614",
	"./es.json": "a306",
	"./fi.json": "5754",
	"./fr.json": "f693",
	"./hu.json": "4e73",
	"./it.json": "0825",
	"./ja.json": "0423",
	"./ko.json": "dd11",
	"./nb.json": "85fc",
	"./nl.json": "a625",
	"./pl.json": "89b2",
	"./pt-BR.json": "03bd",
	"./ru.json": "7704",
	"./sv.json": "4c5b",
	"./vi.json": "aced",
	"./zh-Hans.json": "b2fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";